<template>
    <div class="card">
        <div class="card-header bg-white">
            <h5 class="me-auto">Historial de factura</h5>
        </div>
        <div class="card-body p-0">
            <template>
                <v-data-table class="elevation-1" :headers="headers" :items="items.data" :options.sync="options"
                    :server-items-length="items.total" :loading="loading" :footer-props="{
                        'items-per-page-options': [5, 10, 50, 100]
                    }">
                    <template v-slot:[`item.created_at`]="{ item }">
                        {{ item.created_at | DATETIME }}
                    </template>
                </v-data-table>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    props: ['onhistory'],
    data() {
        return {
            headers: [
                { text: 'Tiempo', value: 'diff_for_humans', sortable: false },
                { text: 'Realizado por', value: 'user.name', sortable: false },
                { text: 'Estado', value: 'state.name', sortable: false },
            ],
            items: {
                data: [],
                total: 0,
                to: 0
            },
            loading: false,
            id: this.$route.params.id,
            options: {}
        }
    },
    methods: {
        INIT: function () {
            let vue = this
            vue.loading = true
            const { page, itemsPerPage } = vue.options
            axios({
                url: '/packages/history/' + vue.id + '/invoice?page=' + page + '&itemsPerPage=' + itemsPerPage,
                method: 'GET'
            })
                .then((resp) => {
                    vue.items = resp.data
                })
                .catch((err) => {
                    if (err.response.status === 402) {
                       let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    } else {
                        vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }
                })
                .finally((resp) => {
                    vue.loading = false
                    vue.$emit('onhistory')
                })
        },
    },
    watch: {
        options: {
            handler() {
                this.INIT(true)
            },
            deep: true
        },
        onhistory: {
            handler(e) {
                if(e == true){
                    this.INIT()
                }
            },
            deep: true
        },
    }
}
</script>